import { render } from "./PlusGradient.vue?vue&type=template&id=ccfc6010"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PlusGradient.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ccfc6010"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ccfc6010', __exports__)) {
    api.reload('ccfc6010', __exports__)
  }
  
  module.hot.accept("./PlusGradient.vue?vue&type=template&id=ccfc6010", () => {
    api.rerender('ccfc6010', render)
  })

}


export default __exports__